import { Mail, Phone } from "lucide-react";
import { COMPANY } from "../data/mock";

export const TopBar = () => {
  return (
    <div className="relative overflow-hidden py-2.5 px-4 text-sm" style={{ background: 'linear-gradient(90deg, #070e24, #0c1839, #070e24)' }}>
      {/* Subtle accent line at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(30,64,175,0.3), rgba(220,38,38,0.2), transparent)' }} />
      
      <div className="max-w-7xl mx-auto flex items-center justify-between relative z-10">
        <div className="flex items-center gap-2.5">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" />
          </span>
          <span className="text-slate-300/80 font-medium text-xs sm:text-[13px] tracking-wide">
            Available 24/7 — Dispatching Now Across Ontario & Cross-Border
          </span>
        </div>
        <div className="hidden sm:flex items-center gap-5">
          <a
            href={`mailto:${COMPANY.email}`}
            className="flex items-center gap-1.5 text-slate-400/80 hover:text-blue-300 transition-colors duration-200 text-xs"
          >
            <Mail size={12} />
            {COMPANY.email}
          </a>
          <div className="w-px h-3 bg-white/10" />
          <a
            href={`tel:${COMPANY.phone}`}
            className="flex items-center gap-1.5 text-slate-400/80 hover:text-blue-300 transition-colors duration-200 text-xs"
          >
            <Phone size={12} />
            {COMPANY.phone}
          </a>
        </div>
      </div>
    </div>
  );
};
